import Vue from "vue";
import App from "./App.vue";
import { sync } from "vuex-router-sync";
import router from "./router";
import store from "./store";
import "bootstrap";
import jquery from "jquery";
import VueCookie from "vue-cookie";
import VCalendar from "v-calendar";
import VueCurrencyFilter from "vue-currency-filter";
import VueBarcode from "@xkeshi/vue-barcode";
import VTooltip from "v-tooltip";
import VueHtmlToPaper from "vue-html-to-paper";

sync(store, router);

// 全域 calendar
Vue.use(VCalendar, {
  firstDayOfWeek: 1,
  data: ["YYYY-MM-DD", "L"]
});
//使用 cookie
Vue.use(VueCookie);
//千分位錢符號

Vue.use(VueCurrencyFilter, {
  thousandsSeparator: ",",
  fractionSeparator: ",",
  symbolPosition: "front",
  symbolSpacing: true
});
// Object.defineProperty(Vue.prototype, "$printJS", {
//   value: print
// });

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: ["print.css"]
};

Vue.use(VueHtmlToPaper, options);
Vue.component("barcode", VueBarcode);
Vue.use(VTooltip);
Vue.config.productionTip = false;
Vue.prototype.$jquery = jquery;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
